var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIdialogueIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34.798mm",
    height: "28.915mm",
    viewBox: "0 0 34.798 28.915",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f60"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.0031204,
    width: 4.5299,
    height: 4.4906,
    fillRule: "evenodd",
    strokeWidth: 0.26458
  }), /*#__PURE__*/React.createElement("rect", {
    y: 6.3794,
    width: 4.5051,
    height: 19.545,
    fillRule: "evenodd",
    strokeWidth: 0.26458
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.2774 4.7819v16.42l7.1117 0.0084s6.3478-1.3567 6.1258-8.3026c0-7.2631-6.1053-8.0987-6.1053-8.0987z",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.703 0.032466s11.396 0.21749 11.788 12.788c-0.21748 13.093-11.788 12.962-11.788 12.962l6.916 0.08699 12.179 3.0448-4.6541-5.9591-0.0435-22.923z",
    strokeWidth: 0
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdialogueIcon);
export default __webpack_public_path__ + "static/media/idialogue-icon.56f19bb5c15e343ed440aba6ffb6d2f5.svg";
export { ForwardRef as ReactComponent };